// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"522":"52e21f7b","4773":"7e1818e2","5410":"52e21f7b"}[chunkId] + ".chunk.css";
};